import RankOne from '@assets/icons/rank-one.svg'
import { Icon } from './Icon'

export const RankOneIcon = Icon(RankOne)
